import Nullstack from 'nullstack';
export default function IconBooks({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-books",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "4",
    width: "4",
    height: "16",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "9",
    y: "4",
    width: "4",
    height: "16",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M5 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M9 16h4"
  }), "   ", Nullstack.element("path", {
    d: "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
  }), "   ", Nullstack.element("path", {
    d: "M14 9l4 -1"
  }), "   ", Nullstack.element("path", {
    d: "M16 16l3.923 -.98"
  }), " ");
}